/* eslint-disable quote-props */

export const available = {
  'checagem': 'Checagem',
  'simulação': 'Simulação',
  'análise': 'Análise',
  'pendente': 'Pendente',
  'pré_aprovada': 'Pré-aprovada',
  'recusada': 'Recusada',
  'restrição': 'Restrição',
  'desistencia': 'Desistência',
  'aprovada': 'Aprovada',
  'formalizada': 'Formalizada',
  'faturada': 'Faturada',
  'pago': 'Pago',
  'expirada': 'Expirada',
  'cancelada': 'Cancelada',
};

export const STATES = Object.keys(available).map(key => ({
  label: available[key],
  value: key,
}));

export default function status(value) {
  return available[value] || value;
}
